export default __webpack_public_path__ + "static/media/brown-arrow.2b46cfeb.svg";